
  import { Component, Vue } from 'vue-property-decorator';
  import VueCookies from 'vue-cookies';

  import { mapGetters } from 'vuex';
  import moment from 'moment';

  import Information from '@/components/Account/Information.vue';
  import Newsletter from '@/components/Account/Newsletter.vue';
  import Cookies from '@/components/Account/Cookies.vue';
  import DeletionRequest from '@/components/Account/DeletionRequest.vue';

  import routeService from '@/services/route.service';
  import tokenService from '@/services/token.service';

  Vue.use(VueCookies);

  @Component({
    components: {
      Information,
      Newsletter,
      Cookies,
      DeletionRequest
    },
    computed: {
      ...mapGetters([
        'user',
        'token',
        'isLoading',
        'redirectUrl'
      ])
    }
  })
  export default class AccountHome extends Vue {
    data() {
      return {
        createdAt: '',
        frontUrl: '',
        showNewsletterSection: false,
        showConnectSection: false,
        showDeletionSection: false, 
        hasCustomCookiesManagement: false,
      }
    };

    created() {

      if (tokenService.hasToken(this) == null) {
        routeService.redirectToLogin(this, this.$router.currentRoute.path);
      }

      this.$data.frontUrl = this.$data.RCEnvironment.VUE_APP_FRONT_URL;
      this.$data.showNewsletterSection = this.$data.RCEnvironment.VUE_APP_ENABLE_NEWSLETTER_SECTION == true;
      this.$data.showConnectSection = this.$data.RCEnvironment.VUE_APP_ENABLE_CONNECTIONS_SECTION == true;
      this.$data.showDeletionSection = this.$data.RCEnvironment.VUE_APP_ENABLE_DELETION_SECTION == true;
      this.$data.hasCustomCookiesManagement = this.$data.RCEnvironment.VUE_APP_HAS_CUSTOM_COOKIES_MANAGEMENT == true;

      this.$store.watch(() => this.$store.getters.user, user => {
        this.$set(this.$data, 'createdAt', moment(user.CreatedAt).format('DD/MM/YY'));
      });

      if (this.$store.getters.user != null) {
        this.$set(this.$data, 'createdAt', moment(this.$store.getters.user.CreatedAt).format('DD/MM/YY'));
      }
    }

    logOut() {
      tokenService.logOut(this);
    }
  }

